'use client';

import { useState } from 'react';

export default function WaitlistForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setStatus('loading');

    try {
      const res = await fetch('https://api.ottothebutler.com/api/waitlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  }

  if (status === 'success') {
    return (
      <p className="text-[var(--otto-pink)] text-sm">
        You&apos;re on the list. We&apos;ll let you know when WhatsApp is ready.
      </p>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex gap-2">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        required
        className="flex-1 px-4 py-3 rounded-lg bg-[var(--otto-dark)] border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:border-[var(--otto-pink)] text-sm"
      />
      <button
        type="submit"
        disabled={status === 'loading'}
        className="px-5 py-3 bg-[var(--otto-pink)] hover:bg-[#d48daa] text-[var(--otto-darker)] font-semibold rounded-lg transition-colors text-sm disabled:opacity-50"
      >
        {status === 'loading' ? '...' : 'Notify me'}
      </button>
      {status === 'error' && (
        <p className="text-red-400 text-xs mt-1">Something went wrong. Try again.</p>
      )}
    </form>
  );
}
